import React from 'react';
import styled, { withTheme } from 'styled-components';
// import BigNumber from 'bignumber.js';
import { TopNavBar, Screen, BottomTabBar, FavList } from '../components';

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const Favorites = ({ theme, pairs }) => (
  <Screen theme={theme} title="Favorites">
    <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <FavList pairs={pairs} />
    </Content>
    <BottomTabBar selected="favorites" />
  </Screen>
);

export default withTheme(Favorites);



// WEBPACK FOOTER //
// ./src/containers/Favorites.js